import React from 'react';

import { Avatar } from '../Avatar';
// Switch to CSS vars for tokens
import Text from '../Typography/Text';
import {
  avatarWrapperStyles,
  contentStyles,
  contentWrapperStyles,
  getBubbleStyles,
  getHeaderStyles,
  getOuterWrapperStyles,
  getRootStyles,
  getTimestampStyles,
} from './MessageBubble.styles';
import { MessageBubbleVariant } from './MessageBubble.types';

export type MessageBubbleProps = {
  /**
   * Visual variant of the message bubble
   */
  variant?: MessageBubbleVariant;
  /**
   * Optional timestamp to display
   */
  timestamp?: string;
  /**
   * Optional avatar image URL
   */
  avatarSrc?: string;
  /**
   * Optional author name to display
   */
  author?: string;
  /**
   * Additional CSS class names
   */
  className?: string;
  /**
   * Content to display in the message bubble
   */
  children?: React.ReactNode;
};

const MessageBubble = ({
  variant = 'sent',
  timestamp,
  avatarSrc,
  author,
  className,
  children,
}: MessageBubbleProps) => {
  const hasAvatar = !!avatarSrc || !!author;
  const firstName = author?.split(' ')[0];

  return (
    <div className={className} css={getRootStyles(variant)}>
      <div css={getOuterWrapperStyles(variant)}>
        {hasAvatar && (
          <div css={avatarWrapperStyles}>
            <Avatar
              type={avatarSrc ? 'image' : 'text'}
              src={avatarSrc}
              text={author}
              alt={author || 'Avatar'}
              size="md"
            />
          </div>
        )}
        <div css={contentWrapperStyles}>
          {firstName && (
            <div css={getHeaderStyles(variant)}>
              <Text size="sm" fontWeight="semibold" color="var(--text-primary)">
                {firstName}
              </Text>
            </div>
          )}
          <div css={getBubbleStyles(variant)}>
            <div css={contentStyles}>{children}</div>
            {timestamp && (
              <Text
                size="xs"
                color="var(--text-secondary)"
                css={getTimestampStyles(variant)}
              >
                {timestamp}
              </Text>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MessageBubble;
